import { dayjsExtension } from "@/utils/days";

export type FormatterKey = "cnpj" | "date" | "postalCode" | "phoneNumber";

export const formatDate = (date: Date | string, format: string) => dayjsExtension(date).format(format);

export const digitsOnly = (value: string) => value.replace(/\D/g, "");

export const formatValue = (key: FormatterKey, value: string | number | boolean | Date | undefined | null) => {
  if (value === undefined || value === null) return "Não informado";

  const cep = String(value).replace(/\D/g, "");

  switch (key) {
    case "date":
      return dayjsExtension(new Date(String(value)))
        .format("DD/MM/YYYY 'às' HH:mm")
        .toString();

    case "cnpj":
      return formatCnpj(String(value));

    case "phoneNumber":
      return formatPhoneNumber(String(value));

    case "postalCode":
      return cep.replace(/^(\d{5})(\d{3})$/, "$1-$2");
  }
};

export const formatCnpj = (cnpj: string | null) => {
  if (!cnpj) return "-";

  const digits = cnpj.replace(/\D/g, "");
  if (digits.length !== 14) return cnpj;

  return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
};

export const formatPhoneNumber = (phoneNumber: string) => {
  const digits = phoneNumber.replace(/\D/g, "");

  if (digits.length === 11) return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
  if (digits.length === 10) return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");

  return phoneNumber;
};

export const formatNameInitials = (name: string) => {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase() ?? "")
    .join("");
};

export const formatCurrency = (value: number, minimumFractionDigits: number = 2, maximumFractionDigits: number = 2) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
};
